import { MenuItem } from '@mui/material';
import {
    AddIcon,
    DeleteIconsOptions,
    DocumentationIcon,
    DownloadIcon,
    IconMaterialType,
    TrashOutlineIcon
} from "../../../../../../components/buttons/IconButtons";
import ButtonIcon from "../../../../../../components/buttons/ButtonIcon";
import ButtonAction from "../../../../../../components/buttons/ButtonAction";
import {CustomTextField} from "../../../../../../components/CustomTextField";
import {CustomSelectAndChildren} from "../../../../../../components/CustomSelectAndChildren";
import DeleteModal from "../../../../../Modals/DeleteModal";
import {FILE_TYPE} from "../../../../../../Helpers/fileType";
import React from "react";
import {fileSize} from "../../../../../../constant/variable";
import CustomPhotoPickerMultiple from "../../../../../../components/PhotoPicker/CustomPhotoPickerMultiple";
import {getUnitTransByName} from "../../../../Dining/Ingredients/Model/Models";
import GeneralExitSectionsApp from "../../../Functionality/EntryAndExitForms/GeneralExitSectionsApp";
import CustomDateTimePicker from "../../../../../../components/CustomDateTimePicker";
import DepartureSection from "../PlantMaterialControl/DepartureSection";
import {
    getMovementDirectionOption,
    getMovementDirectionSection
} from "../../../Model/Model";
import MovementDirectionSection from "../PlantMaterialControl/MovementDirectionSection";
import { PERIOD_TIME_UNIT_ENUM } from "../../../../../../enums/PeriodTimeUnitEnum";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GeneralExitSections = ({
    emptyFields,
    materialRequest,
    setMaterialRequest,
    photoPicker,
    setPhotoPicker,
    emptyFieldsItems,
    setEmptyFieldsItems
}) => {

    const {
        t,
        handleChange,
        handleChangeTemp,
        handleSelectMovementDirection,
        showDeleteModal,
        setShowDeleteModal,
        selectedLevelId,
        setSelectedLevelId,
        measurementUnitsAll,
        handleAdd,
        handleDeleteItem,
    } = GeneralExitSectionsApp({
        materialRequest,
        setMaterialRequest,
        setEmptyFieldsItems
    });

    const selectedDirectionOption = getMovementDirectionOption(materialRequest?.movementDirection);
    const selectedDirectionSection = getMovementDirectionSection(materialRequest?.movementDirection);
    const SelectedDirectionIcon = selectedDirectionOption?.Icon;

    return (
        <>
            <MovementDirectionSection
                t={t}
                idPrefix={"ges"}
                materialRequest={materialRequest}
                onSelectDirection={handleSelectMovementDirection}
                emptyFields={emptyFields}
            >
                { selectedDirectionSection &&
                <DepartureSection
                    t={t}
                    section={selectedDirectionSection}
                    materialRequest={materialRequest}
                    handleChange={handleChange}
                    emptyFields={emptyFields}
                />
                }
            </MovementDirectionSection>

            { selectedDirectionOption &&
            <div className={'row border-radius-8px border-full-shades-300 mt-3'}>
                <div className={"d-flex align-items-center p-2"}>
                    <div className={`mr-2 ${selectedDirectionOption.iconBackground} p-2 border-radius-8px d-flex align-items-center`}>
                        <SelectedDirectionIcon className={selectedDirectionOption.iconColor}/>
                    </div>
                    <p className={"fs-14px ibl-font-w-600"}>{t(selectedDirectionOption.trans)}</p>
                </div>
                <div className={"border-bottom-shades-300"}/>

                <div className={'row p-3'}>
                    <div className={"p-0"}>
                        <CustomDateTimePicker
                            id={'dp_ges_expected_date_and_time'}
                            name={'expectedDateAndTime'}
                            onChange={(e) => {
                                handleChange({target: {value: e, name: 'expectedDateAndTime'}});
                            }}
                            trans={'expected_date_and_time'}
                            value={materialRequest?.expectedDateAndTime}
                            required={true}
                            openTo={PERIOD_TIME_UNIT_ENUM.DAYS.key}
                            disablePast={true}
                            emptyFields={emptyFields}
                        />
                    </div>

                    <div className={"border-radius-8px border-full-shades-300 px-0"}>
                        <div className={"d-flex p-2"}>
                            <div className={"mr-2"}><IconMaterialType/></div>
                            <p className={"fs-14px ibl-font-w-600"}>{t("materials")}</p>
                        </div>
                        <div className={"border-bottom-shades-300"}/>

                        <div className={"p-3"}>
                            { materialRequest?.items?.map((e, index) => {

                                return <div className={"col-12 p-0 mb-3"}>
                                    <div className={"row border-full-shades-300 background-shades-50 border-radius-8px input-padding-top"}>
                                        <div className='col-sm-12 col-md-4 px-sm-3 pl-md-3 pr-md-3'>
                                            <CustomTextField
                                                required={true}
                                                id={'slt_cea_name'}
                                                name={'name'}
                                                trans={'name'}
                                                length={128}
                                                value={e?.name}
                                                onChange={(e) => handleChangeTemp(e, index)}
                                                emptyFields={emptyFieldsItems}
                                            />
                                        </div>
                                        <div className='col-sm-12 col-md-4 px-sm-3 pl-md-0 pr-md-3'>
                                            <CustomTextField
                                                required={true}
                                                id={'slt_cea_quantity'}
                                                type={"number"}
                                                name={'quantity'}
                                                trans={'quantity'}
                                                length={9}
                                                value={e?.quantity}
                                                onChange={(e) => handleChangeTemp(e, index)}
                                                emptyFields={emptyFieldsItems}
                                            />
                                        </div>
                                        <div className='col-sm-12 col-md-4 px-sm-3 pl-md-0 pr-md-3'>
                                            <div className={"d-flex"}>
                                                <div className={"w-100"}>
                                                    <CustomSelectAndChildren
                                                        id='slt_cea_measurement_unit_id'
                                                        name='measurementUnitId'
                                                        trans='unit'
                                                        label='lbl_cea_measurement_unit_id'
                                                        showNoSelectionOption={false}
                                                        required={true}
                                                        value={e?.measurementUnitId}
                                                        onChange={(e) => handleChangeTemp(e, index)}
                                                        emptyFields={emptyFieldsItems}
                                                    >
                                                        {measurementUnitsAll?.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {t(getUnitTransByName(item.name))}
                                                            </MenuItem>
                                                        ))}
                                                    </CustomSelectAndChildren>
                                                </div>

                                                { materialRequest?.items?.length > 1 &&
                                                <div className={"pl-3"}>
                                                    <ButtonIcon
                                                        id={'btn_cea_delete'}
                                                        Icon={TrashOutlineIcon}
                                                        onClick={() => {
                                                            setSelectedLevelId(e);
                                                            setShowDeleteModal(true);
                                                        }}
                                                        className='btn-outlined-error-600 h-40px w-40px'
                                                        iconProps={'btn-icon-svg-24px'}
                                                    />
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })
                            }

                            <div className='col-12 px-0'>
                                <ButtonAction
                                    id='btn_cea_add_new_material'
                                    name='add_material'
                                    Icon={AddIcon}
                                    splitName={false}
                                    className='btn-outlined-secondary-600-00'
                                    disabled={false}
                                    onClick={() => {
                                        handleAdd();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }

            <div className={'row border-radius-8px border-full-shades-300 mt-3'}>
                <div className={"d-flex p-2"}>
                    <div className={"mr-2"}><DocumentationIcon/></div>
                    <p className={"fs-14px ibl-font-w-600"}>{t("documentation")}</p>
                </div>
                <div className={"border-bottom-shades-300 mb-3"}/>

                <div className={"row mb-60px"}>
                    <p className={"fs-14px ibl-font-w-600 mb-3"}>{t("supporting_documents")} *</p>
                    <div className={'col-12'}>
                        <CustomPhotoPickerMultiple
                            id='fu_cea_file'
                            photoPickerFile={photoPicker}
                            setPhotoPickerFile={setPhotoPicker}
                            accept={{ ...FILE_TYPE.IMAGE_FILES, size: fileSize }}
                            showBtnDeleteItemGallery={true}
                            showBtnCamera={false}
                            deleteIcon={DeleteIconsOptions}
                            downloadIcon={DownloadIcon}
                            showBtnDownload={true}
                            apiDelete={false}
                            disabled={false}
                            required={true}
                            emptyFields={emptyFields && photoPicker?.listFiles?.length === 0}
                        />
                    </div>
                </div>
            </div>

            <DeleteModal
                show={showDeleteModal}
                onHide={() => {
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                data={[selectedLevelId]}
                onClickFn={() => {
                    if (selectedLevelId !== null) {
                        handleDeleteItem(selectedLevelId);
                    }
                    setShowDeleteModal(false);
                    setSelectedLevelId(null);
                }}
                title_modal={t('delete_material')}
                element_modal={t('material')}
            />
        </>
    );
};

export default GeneralExitSections;
